import ValidarDocumento from '@/views/pages/commons/validar-documento/ValidarDocumento'
import ConsultaDeComprasDiretas from '@/views/pages/commons/consulta-compras-diretas/ConsultaDeComprasDiretas'
import CompraDiretaVisualizacao from '@/views/pages/commons/detalhe-compra-direta/CompraDiretaVisualizacao.vue'
import CompraDiretaVisualizacaoDadosGerais from '@/views/pages/commons/detalhe-compra-direta/etapas-visualizacao/CompraDiretaVisualizacaoDadosGerais.vue'
import ItensLotesPublico from '@/views/pages/commons/detalhe-compra-direta/itens/ItensLotesPublico.vue'
import DocumentosVisualizacao from '@/views/pages/commons/detalhe-compra-direta/documentos/DocumentosVisualizacao.vue'
import ResultadoFinal from '@/views/pages/commons/detalhe-compra-direta/resultado/ResultadoFinal.vue'

export default [
    {
        path: '/consulta-compras-diretas',
        name: 'consultaDeComprasDiretas',
        component: ConsultaDeComprasDiretas,
        meta: {
            page: {
                title: 'Compras Diretas Disponíveis',
            },
        }
    },
    {
        path: '/compra-direta-visualizacao/:id',
        name: 'compraDiretaVisualizacao',
        component: CompraDiretaVisualizacao,
        redirect: '/compra-direta-visualizacao/:id/dados-gerais',
        children:[
            {
                path: 'dados-gerais',
                name: 'compraDiretaVisualizacaoDadosGerais',
                component: CompraDiretaVisualizacaoDadosGerais,
                meta: {
                    page: {
                        title: 'Dados Gerais',
                    }
                }
            },
            {
                path: 'itensLotes',
                name: 'itensLotesPublico',
                component: ItensLotesPublico,
                meta: {
                    page: {
                        title: 'Itens e Lotes',
                    }
                }
            },
            {
                path: 'documentos',
                name: 'documentosPublicos',
                component: DocumentosVisualizacao,
                meta: {
                    page: {
                        title: 'Documentos',
                    }
                }
            },
            {
                path: 'resultado',
                name: 'resultadoPublicos',
                component: ResultadoFinal,
                meta: {
                    page: {
                        title: 'Resultado',
                    }
                }
            },
        ]
    },
    {
        path: '/validar-documento',
        name: 'ValidarDocumento',
        component: ValidarDocumento,
        meta: {
            page: {
                title: 'Documento',
                subtitle: 'Validar Documento'
            },
        }
    },
    {
        path: '/validar-documento/:codigo',
        name: 'ValidarDocumentoDireto',
        component: ValidarDocumento,
        meta: {
            page: {
                title: 'Documento',
                subtitle: 'Validar Documento'
            },
        }
    },
    {
        path: '*',
        redirect: '/consulta-compras-diretas'
    },
    {
        path: '/redirect-compra/:id',
        name: 'redirectCompra',
        component: {
            render() { return null }
        }
    }
]
